export enum AssetTypes {
  FILE = 'file',
  HTML = 'html',
  LINK = 'link',
  TEXT = 'text',
  PROMPT = 'prompt'
}

export type TypeOfAsset = AssetTypes.TEXT | AssetTypes.HTML | AssetTypes.LINK | AssetTypes.FILE | AssetTypes.PROMPT;

export enum DisplayTypes {
  IMAGE = 'image',
  VIDEO = 'video',
  OEMBED = 'oembed',
  LINK = 'link'
}

export type TypeofDisplay =
  DisplayTypes.IMAGE |
  DisplayTypes.VIDEO |
  DisplayTypes.OEMBED |
  DisplayTypes.LINK;

export type DraftAsset = {
    type: 'text' | 'html' | 'link' | 'prompt' | 'unknown';
    value: string;
}